




























import BaseComponent from '@/components/base-component.vue';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BagModelQuantity from '../bag-model-quantity.vue';
@Component({
  components: {
    BagModelQuantity,
  },
})
export default class PrescriptionFormBagType extends BaseComponent {
  @Prop()
  public item;

  @Prop()
  public disabled;

  @Prop()
  public draft: PrescricaoParmDTO;

  private isBolsaCompartHabilit() {
    return (
      this.item.bolsaMulticompart ||
      (this.item &&
        this.item.unidade &&
        this.item.unidade.usoBolsaMulticompart &&
        this.item.unidade.usoBolsaMulticompart.permiteUso)
    );
  }

  private isBolsaCompartExigida() {
    return this.item && this.item.unidade && this.item.unidade.usoBolsaMulticompart && this.item.unidade.usoBolsaMulticompart.exigirUso;
  }

  @Watch('draft', {immediate: true})
  onChangeDraft(draft: PrescricaoParmDTO) {
    this.sleepUntil(() => {
      return this.item && this.item.unidade && this.item.unidade.usoBolsaMulticompart != null;
    }, 180000).then(() => {
      if (draft == null) {
        return;
      }
      this.item.bolsaMulticompart = draft.bolsaMulticompart && this.isBolsaCompartHabilit();
      this.item.quantidade = this.isBolsaCompartHabilit() ? draft.quantidadePrescricoes : 1;
    })
  }
}
